/* LATTICE card views 2026-11-04 · corner 'Show back / side / front' toggle + view dots + tee colour swatches
   (snippets/card-product.liquid). Delegated, loads once. Views = real product images from the card's data (rest image + extras),
   follow the colour swatch, lazy (srcset only set when a card nears the viewport or is toggled), every card always loads on its
   own default (hoodie back, tee/mug/poster front); a pick is never carried to other cards (session memory removed 2026-11-04). Instant swap with prefers-reduced-motion. */
(function () {
  if (window.__ppCardSw) return; window.__ppCardSw = 1;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)'), KEY = 'ppCardView';
  function card(el) { return el.closest('.card-wrapper, [data-pp-card]'); } // [data-pp-card]: own-card sections (snippets/pp-card-views.liquid)
  function pref() { try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  try { sessionStorage.removeItem(KEY); } catch (e) {} // clear any view kept by the earlier build
  // state per card: list of views [{k, ss, alt}], index 0 = resting image (no overlay)
  function views(c) {
    var w = c.classList.contains('pp-views') ? c : c.querySelector('.pp-views'); if (!w) return null;
    if (!w._v) {
      var ks = (w.dataset.vk || '').split(',').filter(Boolean), vs = (w.dataset.vs || '').split('^^');
      w._v = [{ k: w.dataset.rest || 'front' }].concat(ks.map(function (k, i) { var p = (vs[i] || '').split('~~'); return { k: k, ss: p[0], alt: p[1] || '' }; }).filter(function (v) { return v.ss; }));
      w._i = 0;
    }
    return w;
  }
  function label(w, k) { return w.dataset['l' + k.charAt(0).toUpperCase() + k.slice(1)] || k; }
  function preload(w) {
    var c = card(w), m = c && c.querySelector('.pp-card-front'); if (!m) return;
    // nothing is fetched until a view is picked (or remembered); only then is the overlay's srcset set
    if (!m.getAttribute('srcset')) m.setAttribute('loading', 'lazy');
  }
  function render(w) {
    var c = card(w), m = c.querySelector('.pp-card-front'), b = w.querySelector('.pp-card-flip'), d = w.querySelector('.pp-dots');
    var V = w._v, i = w._i, cur = V[i], nx = V[(i + 1) % V.length], nm = w.dataset.nm;
    w.hidden = V.length < 2;
    m.style.transition = RM.matches ? 'none' : '';
    if (i === 0) { m.setAttribute('aria-hidden', 'true'); m.alt = ''; }
    else {
      var show = function () { m.setAttribute('aria-hidden', 'false'); };
      m.alt = cur.alt;
      if (m.getAttribute('srcset') !== cur.ss) {
        m.setAttribute('aria-hidden', 'true');
        m.onload = m.onerror = function () { m.onload = m.onerror = null; if (w._v[w._i] === cur) show(); };
        m.removeAttribute('loading'); m.setAttribute('srcset', cur.ss);
        if (m.complete && m.currentSrc) show();
      } else show();
    }
    // label names the NEXT view; several sides are numbered in the dots, the badge just says 'Show side' until back to rest
    var lb = label(w, nx.k);
    b.querySelector('.pp-card-flip__t').textContent = lb;
    b.setAttribute('aria-label', lb + ': ' + nm);
    b.setAttribute('aria-pressed', i === 0 ? 'false' : 'true');
    if (d.childElementCount !== V.length || d._sig !== V.map(function (v) { return v.ss; }).join()) {
      d.textContent = ''; d._sig = V.map(function (v) { return v.ss; }).join();
      var n = {}; V.forEach(function (v) { n[v.k] = (n[v.k] || 0) + 1; });
      var seen = {};
      V.forEach(function (v, j) {
        seen[v.k] = (seen[v.k] || 0) + 1;
        var x = document.createElement('button'); x.type = 'button'; x.className = 'pp-dot'; x.dataset.i = j;
        x.setAttribute('aria-label', label(w, v.k) + (n[v.k] > 1 ? ' ' + seen[v.k] : '') + ': ' + nm);
        d.appendChild(x);
      });
    }
    [].forEach.call(d.children, function (x, j) { x.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
  }
  function go(w, i, remember) {
    w._i = (i + w._v.length) % w._v.length; render(w);
  }
  function applyPref(w) {
    // no-op: picks are per card only, never applied to other cards
  }
  function init(w) {
    if (w._init) return; w._init = 1; views(w); render(w);
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { var w = e.target; io.unobserve(w); init(w); preload(w); applyPref(w); } });
  }, { rootMargin: '200px 0px' }) : null;
  function scan(root) {
    (root || document).querySelectorAll('.pp-views').forEach(function (w) {
      if (w._seen) return; w._seen = 1; views(w);
      // label text right away (no network); images wait for the observer
      var V = w._v, b = w.querySelector('.pp-card-flip__t'); if (V.length > 1 && !b.textContent) b.textContent = label(w, V[1].k);
      if (io) io.observe(w); else { init(w); applyPref(w); }
    });
  }
  // JS-built cards (recently viewed, gift finder): [data-pp-hv=handle] fetches the same Liquid view markup (product.pp-views) when near view
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var hio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { hio.unobserve(e.target); hyd(e.target); } });
  }, { rootMargin: '200px 0px' }) : null;
  function hyd(li) {
    var h = li.dataset.ppHv; if (!h) return;
    fetch(root + 'products/' + encodeURIComponent(h) + '?view=pp-views', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { t = (t || '').trim(); if (t.indexOf('pp-views') > -1 && !li.querySelector('.pp-views')) li.insertAdjacentHTML('beforeend', t); }).catch(function () {});
  }
  function hscan(r) { (r || document).querySelectorAll('[data-pp-hv]').forEach(function (li) { if (li._hv) return; li._hv = 1; if (hio) hio.observe(li); else hyd(li); }); }
  var _scan = scan; scan = function (r) { _scan(r); hscan(r); };
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  new MutationObserver(function () { scan(); }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var f = e.target.closest('.pp-card-flip, .pp-dot');
    if (f) {
      e.preventDefault(); e.stopPropagation();
      var w = f.closest('.pp-views'); init(w);
      go(w, f.classList.contains('pp-dot') ? +f.dataset.i : w._i + 1, true); return;
    }
    var s = e.target.closest('.pp-sw__b'); if (!s) return;
    e.preventDefault(); e.stopPropagation();
    var c = card(s); if (!c || s.getAttribute('aria-pressed') === 'true') return;
    c.querySelectorAll('.pp-sw__b').forEach(function (x) {
      var on = x === s; x.setAttribute('aria-pressed', on ? 'true' : 'false');
      x.firstElementChild.style.boxShadow = '0 0 0 1px #9a9a9a' + (on ? ',0 0 0 3px #fff,0 0 0 5px #121212' : '');
    });
    var img = c.querySelector('.card__media .media > img');
    if (img && s.dataset.srcset) {
      img.removeAttribute('loading');
      img.setAttribute('srcset', s.dataset.srcset); img.src = s.dataset.srcset.split(' ')[0]; img.alt = s.dataset.alt || img.alt;
      if (!RM.matches && img.animate) img.animate([{ opacity: .4 }, { opacity: 1 }], { duration: 160, easing: 'ease-out' });
    }
    c.querySelectorAll('a.full-unstyled-link').forEach(function (a) { a.href = s.dataset.url; });
    var w = c.querySelector('.pp-views');
    if (w) {
      views(w); w._init = 1;
      var k = w._v[w._i].k;
      // views follow the colour: rest = this colour's image, extra = this colour's back (if it has one)
      w._v = [w._v[0]].concat(s.dataset.front ? [{ k: 'back', ss: s.dataset.front, alt: s.dataset.frontAlt || '' }] : []);
      w._i = 0; for (var j = 0; j < w._v.length; j++) if (w._v[j].k === k) w._i = j;
      render(w);
    }
  });
})();
